import { Typography } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import { SuppliersTableRow } from '../../types/suppliersTableRow'
import { SuppliersTableNoDataField } from '../SuppliersTableNoDataField'

interface SuppliersTableNameCellProps {
  row: SuppliersTableRow
}

export const SuppliersTableNameCell = ({ row }: SuppliersTableNameCellProps): ReactElement => {
  if (row.name === null || row.name === '') {
    return <SuppliersTableNoDataField />
  }

  return <Typography.Text>{row.name}</Typography.Text>
}
